import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import OptionAppMenu from "./OptionAppMenu";
import LeftSecondaryMenu from "./LeftSecondaryMenu";
import OptionNav from "../OptionNav/OptionNav";
import useMediaQuery from "app/hooks/useMediaQuery";
import "./AppMenu.css";

function LeftMenu({ name, type, section, menuOptions, ...props }) {
  const is4K = useMediaQuery("(min-width: 3840px)");
  const [show, setShow] = useState(false);

  const ROOT = process.env.REACT_APP_CMS_STATIC;

  const handleClose = () => setShow(false);
  const toggleShow = () => setShow((s) => !s);

  return (
    <>
      <OptionAppMenu
        name={name}
        title="Navegación"
        mini={true}
        url="/"
        onClick={toggleShow}
      />
      <Offcanvas
        backdrop={false}
        className={`${is4K && "offcanvas-4K"}`}
        show={show}
        onHide={handleClose}
        style={{
          backgroundColor: "#001a70",
          color: "white",
          marginTop: "53px",
          width: "400px",
        }}
        {...props}
      >
        <Offcanvas.Body>
          <div>
            {menuOptions.map((option, index) =>
              option.displayText === "Ahorro Y Crédito" ? (
                <LeftSecondaryMenu
                  key={index}
                  name={option?.displayText}
                  title={option?.displayText}
                  section={index + 1}
                  closeLeft={handleClose}
                  iconUrl={ROOT + option?.icono?.urls[0]}
                />
              ) : (
                <OptionNav
                  key={index}
                  name={option?.displayText}
                  icon={ROOT + option?.icono?.urls[0]}
                  title={option?.displayText}
                  url={option?.rutadestino}
                  textColor="#fff"
                />
              )
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default LeftMenu;
